import { render, staticRenderFns } from "./Grupa.vue?vue&type=template&id=7c00af14&scoped=true&"
import script from "./Grupa.vue?vue&type=script&lang=js&"
export * from "./Grupa.vue?vue&type=script&lang=js&"
import style0 from "./Grupa.vue?vue&type=style&index=0&id=7c00af14&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c00af14",
  null
  
)

export default component.exports